import React from "react";
import { StarIcon } from "lucide-react";
interface StarsProps {
  size?: number;
  className?: string;
}
export function Stars({
  size = 16,
  className = ""
}: StarsProps) {
  return <div className={`flex items-center gap-0.5 ${className}`} aria-label="5 de 5 estrellas" data-id="element-193" data-mp="3kqemqjbutf2u">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="text-amber-400" style={{
      width: size,
      height: size
    }} fill="currentColor" strokeWidth={0} data-id="element-194" data-mp="3pqsyabcnz75m" data-mpi={i} />)}
    </div>;
}